// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2nI1-","content":"styles_content__2ic2-","checkbox":"styles_checkbox__1up1n","checkboxLabel":"styles_checkboxLabel__3Hf1L"};